import type { EnumItem } from "@/types/pt_types"

export type AccountTypeName = 'ADMIN' | 'APP'
export class AccountType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ADMIN = new AccountType('后台账号', 'ADMIN')
  static readonly APP = new AccountType('前端账号', 'APP')
  private static readonly VALUES: AccountType[] = [this.ADMIN, this.APP] as const

  static names(): AccountTypeName[] {
    return ['ADMIN', 'APP']
  }

  static values(): AccountType[] {
    return this.VALUES
  }

  static fromValue(value?: string): AccountType | undefined {
    return value === undefined ? undefined : AccountType.values().find(e => e.value === value)
  }
}
export type AlbumTypeName = 'PHOTO' | 'VIDEO'
export class AlbumType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PHOTO = new AlbumType('照片', 'PHOTO')
  static readonly VIDEO = new AlbumType('视频', 'VIDEO')
  private static readonly VALUES: AlbumType[] = [this.PHOTO, this.VIDEO] as const

  static names(): AlbumTypeName[] {
    return ['PHOTO', 'VIDEO']
  }

  static values(): AlbumType[] {
    return this.VALUES
  }

  static fromValue(value?: string): AlbumType | undefined {
    return value === undefined ? undefined : AlbumType.values().find(e => e.value === value)
  }
}
export type AuditStatusName = 'UNSUBMIT' | 'PENDING' | 'APPROVED' | 'REJECTED' | 'EXPIRING' | 'REVIEWING' | 'EXPIRED'
export class AuditStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly UNSUBMIT = new AuditStatus('待审核', 'UNSUBMIT')
  static readonly PENDING = new AuditStatus('审核中', 'PENDING')
  static readonly APPROVED = new AuditStatus('已认证', 'APPROVED')
  static readonly REJECTED = new AuditStatus('已拒绝', 'REJECTED')
  static readonly EXPIRING = new AuditStatus('即将过期', 'EXPIRING')
  static readonly REVIEWING = new AuditStatus('复查中', 'REVIEWING')
  static readonly EXPIRED = new AuditStatus('已过期', 'EXPIRED')
  private static readonly VALUES: AuditStatus[] = [this.UNSUBMIT, this.PENDING, this.APPROVED, this.REJECTED, this.EXPIRING, this.REVIEWING, this.EXPIRED] as const

  static names(): AuditStatusName[] {
    return ['UNSUBMIT', 'PENDING', 'APPROVED', 'REJECTED', 'EXPIRING', 'REVIEWING', 'EXPIRED']
  }

  static values(): AuditStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): AuditStatus | undefined {
    return value === undefined ? undefined : AuditStatus.values().find(e => e.value === value)
  }
}
export type AuditTypeName = 'NEW_MERCHANT' | 'MERCHANT' | 'SKILL'
export class AuditType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly NEW_MERCHANT = new AuditType('申请新商户', 'NEW_MERCHANT')
  static readonly MERCHANT = new AuditType('商户审核', 'MERCHANT')
  static readonly SKILL = new AuditType('服务商技能审核', 'SKILL')
  private static readonly VALUES: AuditType[] = [this.NEW_MERCHANT, this.MERCHANT, this.SKILL] as const

  static names(): AuditTypeName[] {
    return ['NEW_MERCHANT', 'MERCHANT', 'SKILL']
  }

  static values(): AuditType[] {
    return this.VALUES
  }

  static fromValue(value?: string): AuditType | undefined {
    return value === undefined ? undefined : AuditType.values().find(e => e.value === value)
  }
}
export type BalanceTypeName = 'AVAILABLE' | 'FROZEN' | 'PENDING'
export class BalanceType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly AVAILABLE = new BalanceType('可用余额', 'AVAILABLE')
  static readonly FROZEN = new BalanceType('冻结余额', 'FROZEN')
  static readonly PENDING = new BalanceType('待结算金额', 'PENDING')
  private static readonly VALUES: BalanceType[] = [this.AVAILABLE, this.FROZEN, this.PENDING] as const

  static names(): BalanceTypeName[] {
    return ['AVAILABLE', 'FROZEN', 'PENDING']
  }

  static values(): BalanceType[] {
    return this.VALUES
  }

  static fromValue(value?: string): BalanceType | undefined {
    return value === undefined ? undefined : BalanceType.values().find(e => e.value === value)
  }
}
export type BatchTaskTypeName = 'PRODUCT_SUMMARY_UPDATE' | 'SELLER_SUMMARY_UPDATE' | 'BOOK_SUMMARY_UPDATE'
export class BatchTaskType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PRODUCT_SUMMARY_UPDATE = new BatchTaskType('产品聚合信息更新', 'PRODUCT_SUMMARY_UPDATE')
  static readonly SELLER_SUMMARY_UPDATE = new BatchTaskType('卖家聚合信息更新', 'SELLER_SUMMARY_UPDATE')
  static readonly BOOK_SUMMARY_UPDATE = new BatchTaskType('预订聚合信息更新', 'BOOK_SUMMARY_UPDATE')
  private static readonly VALUES: BatchTaskType[] = [this.PRODUCT_SUMMARY_UPDATE, this.SELLER_SUMMARY_UPDATE, this.BOOK_SUMMARY_UPDATE] as const

  static names(): BatchTaskTypeName[] {
    return ['PRODUCT_SUMMARY_UPDATE', 'SELLER_SUMMARY_UPDATE', 'BOOK_SUMMARY_UPDATE']
  }

  static values(): BatchTaskType[] {
    return this.VALUES
  }

  static fromValue(value?: string): BatchTaskType | undefined {
    return value === undefined ? undefined : BatchTaskType.values().find(e => e.value === value)
  }
}
export type BindingTypeName = 'PHONE' | 'EMAIL' | 'WEIXIN'
export class BindingType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PHONE = new BindingType('手机', 'PHONE')
  static readonly EMAIL = new BindingType('邮箱', 'EMAIL')
  static readonly WEIXIN = new BindingType('微信', 'WEIXIN')
  private static readonly VALUES: BindingType[] = [this.PHONE, this.EMAIL, this.WEIXIN] as const

  static names(): BindingTypeName[] {
    return ['PHONE', 'EMAIL', 'WEIXIN']
  }

  static values(): BindingType[] {
    return this.VALUES
  }

  static fromValue(value?: string): BindingType | undefined {
    return value === undefined ? undefined : BindingType.values().find(e => e.value === value)
  }
}
export type BizRefTypeName = 'ACCOUNT' | 'ADMIN' | 'USER' | 'EMPLOYEE' | 'PROVIDER' | 'CATEGORY' | 'SKILL' | 'SELLER' | 'MERCHANT' | 'PRIVILEGE' | 'TENANT' | 'FILE' | 'ROLE' | 'RESOURCE' | 'WALLET' | 'PAY_ORDER' | 'ORDER' | 'ORDER_ITEM' | 'RECHARGE_ORDER' | 'WITHDRAW_ORDER' | 'REFUND_ORDER' | 'WORK_ORDER' | 'COUPON' | 'COUPON_SET' | 'CART_ITEM' | 'SPU' | 'SKU' | 'TRADE_LOG' | 'BOOK_RECORD'
export class BizRefType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ACCOUNT = new BizRefType('账号', 'ACCOUNT')
  static readonly ADMIN = new BizRefType('管理员', 'ADMIN')
  static readonly USER = new BizRefType('用户', 'USER')
  static readonly EMPLOYEE = new BizRefType('商户员工', 'EMPLOYEE')
  static readonly PROVIDER = new BizRefType('服务商', 'PROVIDER')
  static readonly CATEGORY = new BizRefType('类目', 'CATEGORY')
  static readonly SKILL = new BizRefType('技能', 'SKILL')
  static readonly SELLER = new BizRefType('卖家', 'SELLER')
  static readonly MERCHANT = new BizRefType('商户', 'MERCHANT')
  static readonly PRIVILEGE = new BizRefType('权限', 'PRIVILEGE')
  static readonly TENANT = new BizRefType('租户', 'TENANT')
  static readonly FILE = new BizRefType('文件', 'FILE')
  static readonly ROLE = new BizRefType('角色', 'ROLE')
  static readonly RESOURCE = new BizRefType('资源', 'RESOURCE')
  static readonly WALLET = new BizRefType('钱包', 'WALLET')
  static readonly PAY_ORDER = new BizRefType('支付订单', 'PAY_ORDER')
  static readonly ORDER = new BizRefType('订单', 'ORDER')
  static readonly ORDER_ITEM = new BizRefType('订单项', 'ORDER_ITEM')
  static readonly RECHARGE_ORDER = new BizRefType('充值订单', 'RECHARGE_ORDER')
  static readonly WITHDRAW_ORDER = new BizRefType('提现订单', 'WITHDRAW_ORDER')
  static readonly REFUND_ORDER = new BizRefType('退款订单', 'REFUND_ORDER')
  static readonly WORK_ORDER = new BizRefType('工单', 'WORK_ORDER')
  static readonly COUPON = new BizRefType('优惠券', 'COUPON')
  static readonly COUPON_SET = new BizRefType('优惠活动', 'COUPON_SET')
  static readonly CART_ITEM = new BizRefType('购物车项', 'CART_ITEM')
  static readonly SPU = new BizRefType('商品', 'SPU')
  static readonly SKU = new BizRefType('商品规格', 'SKU')
  static readonly TRADE_LOG = new BizRefType('交易日志', 'TRADE_LOG')
  static readonly BOOK_RECORD = new BizRefType('预订记录', 'BOOK_RECORD')
  private static readonly VALUES: BizRefType[] = [this.ACCOUNT, this.ADMIN, this.USER, this.EMPLOYEE, this.PROVIDER, this.CATEGORY, this.SKILL, this.SELLER, this.MERCHANT, this.PRIVILEGE, this.TENANT, this.FILE, this.ROLE, this.RESOURCE, this.WALLET, this.PAY_ORDER, this.ORDER, this.ORDER_ITEM, this.RECHARGE_ORDER, this.WITHDRAW_ORDER, this.REFUND_ORDER, this.WORK_ORDER, this.COUPON, this.COUPON_SET, this.CART_ITEM, this.SPU, this.SKU, this.TRADE_LOG, this.BOOK_RECORD] as const

  static names(): BizRefTypeName[] {
    return ['ACCOUNT', 'ADMIN', 'USER', 'EMPLOYEE', 'PROVIDER', 'CATEGORY', 'SKILL', 'SELLER', 'MERCHANT', 'PRIVILEGE', 'TENANT', 'FILE', 'ROLE', 'RESOURCE', 'WALLET', 'PAY_ORDER', 'ORDER', 'ORDER_ITEM', 'RECHARGE_ORDER', 'WITHDRAW_ORDER', 'REFUND_ORDER', 'WORK_ORDER', 'COUPON', 'COUPON_SET', 'CART_ITEM', 'SPU', 'SKU', 'TRADE_LOG', 'BOOK_RECORD']
  }

  static values(): BizRefType[] {
    return this.VALUES
  }

  static fromValue(value?: string): BizRefType | undefined {
    return value === undefined ? undefined : BizRefType.values().find(e => e.value === value)
  }
}
export type BookStatusName = 'LOCK' | 'COMPLETE' | 'CANCEL'
export class BookStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly LOCK = new BookStatus('锁定', 'LOCK')
  static readonly COMPLETE = new BookStatus('完成', 'COMPLETE')
  static readonly CANCEL = new BookStatus('取消', 'CANCEL')
  private static readonly VALUES: BookStatus[] = [this.LOCK, this.COMPLETE, this.CANCEL] as const

  static names(): BookStatusName[] {
    return ['LOCK', 'COMPLETE', 'CANCEL']
  }

  static values(): BookStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): BookStatus | undefined {
    return value === undefined ? undefined : BookStatus.values().find(e => e.value === value)
  }
}
export type BusinessStatusName = 'PREPARING' | 'NORMAL' | 'SUSPENDED' | 'BANNED' | 'CLOSED'
export class BusinessStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PREPARING = new BusinessStatus('申请中', 'PREPARING')
  static readonly NORMAL = new BusinessStatus('正常', 'NORMAL')
  static readonly SUSPENDED = new BusinessStatus('暂停', 'SUSPENDED')
  static readonly BANNED = new BusinessStatus('封禁', 'BANNED')
  static readonly CLOSED = new BusinessStatus('关闭', 'CLOSED')
  private static readonly VALUES: BusinessStatus[] = [this.PREPARING, this.NORMAL, this.SUSPENDED, this.BANNED, this.CLOSED] as const

  static names(): BusinessStatusName[] {
    return ['PREPARING', 'NORMAL', 'SUSPENDED', 'BANNED', 'CLOSED']
  }

  static values(): BusinessStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): BusinessStatus | undefined {
    return value === undefined ? undefined : BusinessStatus.values().find(e => e.value === value)
  }
}
export type CategoryTypeName = 'GOODS' | 'VIRTUAL' | 'SERVICE'
export class CategoryType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly GOODS = new CategoryType('实体商品', 'GOODS')
  static readonly VIRTUAL = new CategoryType('虚拟商品', 'VIRTUAL')
  static readonly SERVICE = new CategoryType('服务', 'SERVICE')
  private static readonly VALUES: CategoryType[] = [this.GOODS, this.VIRTUAL, this.SERVICE] as const

  static names(): CategoryTypeName[] {
    return ['GOODS', 'VIRTUAL', 'SERVICE']
  }

  static values(): CategoryType[] {
    return this.VALUES
  }

  static fromValue(value?: string): CategoryType | undefined {
    return value === undefined ? undefined : CategoryType.values().find(e => e.value === value)
  }
}
export type ChannelTypeName = 'CUSTOMER' | 'SHARE_URL'
export class ChannelType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly CUSTOMER = new ChannelType('客户', 'CUSTOMER')
  static readonly SHARE_URL = new ChannelType('分享链接', 'SHARE_URL')
  private static readonly VALUES: ChannelType[] = [this.CUSTOMER, this.SHARE_URL] as const

  static names(): ChannelTypeName[] {
    return ['CUSTOMER', 'SHARE_URL']
  }

  static values(): ChannelType[] {
    return this.VALUES
  }

  static fromValue(value?: string): ChannelType | undefined {
    return value === undefined ? undefined : ChannelType.values().find(e => e.value === value)
  }
}
export type ClientTypeName = 'API' | 'WEB' | 'APP' | 'WEIXIN' | 'ALIPAY' | 'DOUYIN' | 'QQ' | 'MP_WEIXIN' | 'MP_ALIPAY' | 'MP_DOUYIN' | 'MP_QQ' | 'MP_BAIDU' | 'MP_LARK' | 'MP_KUAISHOU' | 'MP_JD' | 'MP_360' | 'MP_HARMONY' | 'MP_XHS' | 'QUICKAPP_WEBVIEW_UNION' | 'QUICKAPP_WEBVIEW_HUAWEI'
export class ClientType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly API = new ClientType('API', 'API')
  static readonly WEB = new ClientType('WEB', 'WEB')
  static readonly APP = new ClientType('APP', 'APP')
  static readonly WEIXIN = new ClientType('微信', 'WEIXIN')
  static readonly ALIPAY = new ClientType('支付宝', 'ALIPAY')
  static readonly DOUYIN = new ClientType('抖音', 'DOUYIN')
  static readonly QQ = new ClientType('QQ', 'QQ')
  static readonly MP_WEIXIN = new ClientType('微信小程序', 'MP_WEIXIN')
  static readonly MP_ALIPAY = new ClientType('支付宝小程序', 'MP_ALIPAY')
  static readonly MP_DOUYIN = new ClientType('抖音小程序', 'MP_DOUYIN')
  static readonly MP_QQ = new ClientType('QQ小程序', 'MP_QQ')
  static readonly MP_BAIDU = new ClientType('百度小程序', 'MP_BAIDU')
  static readonly MP_LARK = new ClientType('飞书小程序', 'MP_LARK')
  static readonly MP_KUAISHOU = new ClientType('快手小程序', 'MP_KUAISHOU')
  static readonly MP_JD = new ClientType('京东小程序', 'MP_JD')
  static readonly MP_360 = new ClientType('360小程序', 'MP_360')
  static readonly MP_HARMONY = new ClientType('鸿蒙元服务', 'MP_HARMONY')
  static readonly MP_XHS = new ClientType('小红书小程序', 'MP_XHS')
  static readonly QUICKAPP_WEBVIEW_UNION = new ClientType('联盟快应用', 'QUICKAPP_WEBVIEW_UNION')
  static readonly QUICKAPP_WEBVIEW_HUAWEI = new ClientType('华为快应用', 'QUICKAPP_WEBVIEW_HUAWEI')
  private static readonly VALUES: ClientType[] = [this.API, this.WEB, this.APP, this.WEIXIN, this.ALIPAY, this.DOUYIN, this.QQ, this.MP_WEIXIN, this.MP_ALIPAY, this.MP_DOUYIN, this.MP_QQ, this.MP_BAIDU, this.MP_LARK, this.MP_KUAISHOU, this.MP_JD, this.MP_360, this.MP_HARMONY, this.MP_XHS, this.QUICKAPP_WEBVIEW_UNION, this.QUICKAPP_WEBVIEW_HUAWEI] as const

  static names(): ClientTypeName[] {
    return ['API', 'WEB', 'APP', 'WEIXIN', 'ALIPAY', 'DOUYIN', 'QQ', 'MP_WEIXIN', 'MP_ALIPAY', 'MP_DOUYIN', 'MP_QQ', 'MP_BAIDU', 'MP_LARK', 'MP_KUAISHOU', 'MP_JD', 'MP_360', 'MP_HARMONY', 'MP_XHS', 'QUICKAPP_WEBVIEW_UNION', 'QUICKAPP_WEBVIEW_HUAWEI']
  }

  static values(): ClientType[] {
    return this.VALUES
  }

  static fromValue(value?: string): ClientType | undefined {
    return value === undefined ? undefined : ClientType.values().find(e => e.value === value)
  }
}
export type CodeOpTypeName = 'LOGIN' | 'REGISTER' | 'PWD_FORGET' | 'BINDING' | 'UNBINDING' | 'WITHDRAW'
export class CodeOpType implements EnumItem<string> {
  public readonly label: string
  public readonly needLogin: boolean
  public readonly needName: boolean
  public readonly value: string

  private constructor(label: string, needLogin: boolean, needName: boolean, value: string) {
    this.label = label
    this.needLogin = needLogin
    this.needName = needName
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly LOGIN = new CodeOpType('登录', false, true, 'LOGIN')
  static readonly REGISTER = new CodeOpType('注册', false, true, 'REGISTER')
  static readonly PWD_FORGET = new CodeOpType('忘记密码', false, true, 'PWD_FORGET')
  static readonly BINDING = new CodeOpType('绑定', true, true, 'BINDING')
  static readonly UNBINDING = new CodeOpType('解绑', true, false, 'UNBINDING')
  static readonly WITHDRAW = new CodeOpType('提现', true, false, 'WITHDRAW')
  private static readonly VALUES: CodeOpType[] = [this.LOGIN, this.REGISTER, this.PWD_FORGET, this.BINDING, this.UNBINDING, this.WITHDRAW] as const

  static names(): CodeOpTypeName[] {
    return ['LOGIN', 'REGISTER', 'PWD_FORGET', 'BINDING', 'UNBINDING', 'WITHDRAW']
  }

  static values(): CodeOpType[] {
    return this.VALUES
  }

  static fromValue(value?: string): CodeOpType | undefined {
    return value === undefined ? undefined : CodeOpType.values().find(e => e.value === value)
  }
}
export type CodeTypeName = 'PHONE' | 'EMAIL'
export class CodeType implements EnumItem<string> {
  public readonly label: string
  public readonly source: string
  public readonly value: string

  private constructor(label: string, source: string, value: string) {
    this.label = label
    this.source = source
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PHONE = new CodeType('手机验证码', '手机号', 'PHONE')
  static readonly EMAIL = new CodeType('邮箱验证码', '邮箱', 'EMAIL')
  private static readonly VALUES: CodeType[] = [this.PHONE, this.EMAIL] as const

  static names(): CodeTypeName[] {
    return ['PHONE', 'EMAIL']
  }

  static values(): CodeType[] {
    return this.VALUES
  }

  static fromValue(value?: string): CodeType | undefined {
    return value === undefined ? undefined : CodeType.values().find(e => e.value === value)
  }
}
export type CouponStatusName = 'UNUSED' | 'USED' | 'EXPIRED' | 'LOCKED'
export class CouponStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly UNUSED = new CouponStatus('未使用', 'UNUSED')
  static readonly USED = new CouponStatus('已使用', 'USED')
  static readonly EXPIRED = new CouponStatus('已过期', 'EXPIRED')
  static readonly LOCKED = new CouponStatus('已锁住', 'LOCKED')
  private static readonly VALUES: CouponStatus[] = [this.UNUSED, this.USED, this.EXPIRED, this.LOCKED] as const

  static names(): CouponStatusName[] {
    return ['UNUSED', 'USED', 'EXPIRED', 'LOCKED']
  }

  static values(): CouponStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): CouponStatus | undefined {
    return value === undefined ? undefined : CouponStatus.values().find(e => e.value === value)
  }
}
export type CouponTypeName = 'CASH' | 'PERCENT'
export class CouponType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly CASH = new CouponType('现金券', 'CASH')
  static readonly PERCENT = new CouponType('折扣券', 'PERCENT')
  private static readonly VALUES: CouponType[] = [this.CASH, this.PERCENT] as const

  static names(): CouponTypeName[] {
    return ['CASH', 'PERCENT']
  }

  static values(): CouponType[] {
    return this.VALUES
  }

  static fromValue(value?: string): CouponType | undefined {
    return value === undefined ? undefined : CouponType.values().find(e => e.value === value)
  }
}
export type DelayOpTypeName = 'ORDER_ITEM_ACCEPT_NOTIFY_LIMIT' | 'ORDER_ITEM_ACCEPT_LIMIT' | 'ORDER_ITEM_DELIVERING_NOTIFY_LIMIT' | 'ORDER_ITEM_DELIVERING_LIMIT' | 'ORDER_ITEM_DELIVERED_LIMIT' | 'ORDER_ITEM_SETTLE_LIMIT' | 'ORDER_MP_NOTIFY' | 'ORDER_PAY_LIMIT' | 'RECHARGE_PAY_LIMIT'
export class DelayOpType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ORDER_ITEM_ACCEPT_NOTIFY_LIMIT = new DelayOpType('接单通知时限', 'ORDER_ITEM_ACCEPT_NOTIFY_LIMIT')
  static readonly ORDER_ITEM_ACCEPT_LIMIT = new DelayOpType('已到接单时限', 'ORDER_ITEM_ACCEPT_LIMIT')
  static readonly ORDER_ITEM_DELIVERING_NOTIFY_LIMIT = new DelayOpType('开始交付通知时限', 'ORDER_ITEM_DELIVERING_NOTIFY_LIMIT')
  static readonly ORDER_ITEM_DELIVERING_LIMIT = new DelayOpType('已到开始交付时限', 'ORDER_ITEM_DELIVERING_LIMIT')
  static readonly ORDER_ITEM_DELIVERED_LIMIT = new DelayOpType('已到完成交付时限', 'ORDER_ITEM_DELIVERED_LIMIT')
  static readonly ORDER_ITEM_SETTLE_LIMIT = new DelayOpType('已到结算时限', 'ORDER_ITEM_SETTLE_LIMIT')
  static readonly ORDER_MP_NOTIFY = new DelayOpType('小程序收货通知', 'ORDER_MP_NOTIFY')
  static readonly ORDER_PAY_LIMIT = new DelayOpType('已到订单支付时限', 'ORDER_PAY_LIMIT')
  static readonly RECHARGE_PAY_LIMIT = new DelayOpType('已到充值支付时限', 'RECHARGE_PAY_LIMIT')
  private static readonly VALUES: DelayOpType[] = [this.ORDER_ITEM_ACCEPT_NOTIFY_LIMIT, this.ORDER_ITEM_ACCEPT_LIMIT, this.ORDER_ITEM_DELIVERING_NOTIFY_LIMIT, this.ORDER_ITEM_DELIVERING_LIMIT, this.ORDER_ITEM_DELIVERED_LIMIT, this.ORDER_ITEM_SETTLE_LIMIT, this.ORDER_MP_NOTIFY, this.ORDER_PAY_LIMIT, this.RECHARGE_PAY_LIMIT] as const

  static names(): DelayOpTypeName[] {
    return ['ORDER_ITEM_ACCEPT_NOTIFY_LIMIT', 'ORDER_ITEM_ACCEPT_LIMIT', 'ORDER_ITEM_DELIVERING_NOTIFY_LIMIT', 'ORDER_ITEM_DELIVERING_LIMIT', 'ORDER_ITEM_DELIVERED_LIMIT', 'ORDER_ITEM_SETTLE_LIMIT', 'ORDER_MP_NOTIFY', 'ORDER_PAY_LIMIT', 'RECHARGE_PAY_LIMIT']
  }

  static values(): DelayOpType[] {
    return this.VALUES
  }

  static fromValue(value?: string): DelayOpType | undefined {
    return value === undefined ? undefined : DelayOpType.values().find(e => e.value === value)
  }
}
export type EventConsumerGroupName = 'STAT_CONSUMER' | 'ORDER_CONSUMER'
export class EventConsumerGroup implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly STAT_CONSUMER = new EventConsumerGroup('统计消费', 'STAT_CONSUMER')
  static readonly ORDER_CONSUMER = new EventConsumerGroup('订单消费', 'ORDER_CONSUMER')
  private static readonly VALUES: EventConsumerGroup[] = [this.STAT_CONSUMER, this.ORDER_CONSUMER] as const

  static names(): EventConsumerGroupName[] {
    return ['STAT_CONSUMER', 'ORDER_CONSUMER']
  }

  static values(): EventConsumerGroup[] {
    return this.VALUES
  }

  static fromValue(value?: string): EventConsumerGroup | undefined {
    return value === undefined ? undefined : EventConsumerGroup.values().find(e => e.value === value)
  }
}
export type EventTypeName = 'USER_ADD' | 'USER_DEL' | 'MERCHANT_ADD' | 'MERCHANT_DEL' | 'PROVIDER_ADD' | 'PROVIDER_DEL' | 'PAY_ORDER_NOTIFY' | 'REFUND_ORDER_NOTIFY' | 'WITHDRAW_ORDER_NOTIFY' | 'ORDER_PAID' | 'ORDER_ITEM_CANCELED' | 'ORDER_ITEM_REFUNDED'
export class EventType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly USER_ADD = new EventType('新增用户', 'USER_ADD')
  static readonly USER_DEL = new EventType('删除用户', 'USER_DEL')
  static readonly MERCHANT_ADD = new EventType('新增商户', 'MERCHANT_ADD')
  static readonly MERCHANT_DEL = new EventType('删除商户', 'MERCHANT_DEL')
  static readonly PROVIDER_ADD = new EventType('新增服务商', 'PROVIDER_ADD')
  static readonly PROVIDER_DEL = new EventType('删除服务商', 'PROVIDER_DEL')
  static readonly PAY_ORDER_NOTIFY = new EventType('支付订单通知', 'PAY_ORDER_NOTIFY')
  static readonly REFUND_ORDER_NOTIFY = new EventType('退款订单通知', 'REFUND_ORDER_NOTIFY')
  static readonly WITHDRAW_ORDER_NOTIFY = new EventType('提现订单通知', 'WITHDRAW_ORDER_NOTIFY')
  static readonly ORDER_PAID = new EventType('订单已支付', 'ORDER_PAID')
  static readonly ORDER_ITEM_CANCELED = new EventType('订单项取消', 'ORDER_ITEM_CANCELED')
  static readonly ORDER_ITEM_REFUNDED = new EventType('订单项退款', 'ORDER_ITEM_REFUNDED')
  private static readonly VALUES: EventType[] = [this.USER_ADD, this.USER_DEL, this.MERCHANT_ADD, this.MERCHANT_DEL, this.PROVIDER_ADD, this.PROVIDER_DEL, this.PAY_ORDER_NOTIFY, this.REFUND_ORDER_NOTIFY, this.WITHDRAW_ORDER_NOTIFY, this.ORDER_PAID, this.ORDER_ITEM_CANCELED, this.ORDER_ITEM_REFUNDED] as const

  static names(): EventTypeName[] {
    return ['USER_ADD', 'USER_DEL', 'MERCHANT_ADD', 'MERCHANT_DEL', 'PROVIDER_ADD', 'PROVIDER_DEL', 'PAY_ORDER_NOTIFY', 'REFUND_ORDER_NOTIFY', 'WITHDRAW_ORDER_NOTIFY', 'ORDER_PAID', 'ORDER_ITEM_CANCELED', 'ORDER_ITEM_REFUNDED']
  }

  static values(): EventType[] {
    return this.VALUES
  }

  static fromValue(value?: string): EventType | undefined {
    return value === undefined ? undefined : EventType.values().find(e => e.value === value)
  }
}
export type FileRefTypeName = 'ACCOUNT_AVATAR' | 'ACCOUNT_IDCARD' | 'ACCOUNT_IMAGE' | 'PRIV_IMG' | 'SELLER_LOGO' | 'SELLER_CERTIFICATE' | 'SKILL_CERTIFICATE' | 'RES_IMG' | 'AUDIT_IMG' | 'PAY_CHANNEL_IMG' | 'WITHDRAW_CHANNEL_IMG' | 'ORDER_IMG' | 'ORDER_ITEM_IMG' | 'WORK_ORDER_IMG' | 'SPU_LOGO' | 'SPU_IMG' | 'SKU_IMG' | 'TRAN_DETAIL_IMG' | 'NOTIFY_MESSAGE_IMAGE' | 'ALBUM_FILE'
export class FileRefType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ACCOUNT_AVATAR = new FileRefType('头像', 'ACCOUNT_AVATAR')
  static readonly ACCOUNT_IDCARD = new FileRefType('身份证', 'ACCOUNT_IDCARD')
  static readonly ACCOUNT_IMAGE = new FileRefType('相册', 'ACCOUNT_IMAGE')
  static readonly PRIV_IMG = new FileRefType('权限图标', 'PRIV_IMG')
  static readonly SELLER_LOGO = new FileRefType('卖家商标', 'SELLER_LOGO')
  static readonly SELLER_CERTIFICATE = new FileRefType('卖家证书', 'SELLER_CERTIFICATE')
  static readonly SKILL_CERTIFICATE = new FileRefType('技能证书', 'SKILL_CERTIFICATE')
  static readonly RES_IMG = new FileRefType('资源图片', 'RES_IMG')
  static readonly AUDIT_IMG = new FileRefType('审核图片', 'AUDIT_IMG')
  static readonly PAY_CHANNEL_IMG = new FileRefType('支付通道图标', 'PAY_CHANNEL_IMG')
  static readonly WITHDRAW_CHANNEL_IMG = new FileRefType('提现通道图标', 'WITHDRAW_CHANNEL_IMG')
  static readonly ORDER_IMG = new FileRefType('订单图片', 'ORDER_IMG')
  static readonly ORDER_ITEM_IMG = new FileRefType('订单项图片', 'ORDER_ITEM_IMG')
  static readonly WORK_ORDER_IMG = new FileRefType('工单图片', 'WORK_ORDER_IMG')
  static readonly SPU_LOGO = new FileRefType('商品封面', 'SPU_LOGO')
  static readonly SPU_IMG = new FileRefType('商品图片', 'SPU_IMG')
  static readonly SKU_IMG = new FileRefType('商品规格图片', 'SKU_IMG')
  static readonly TRAN_DETAIL_IMG = new FileRefType('交易明细图片', 'TRAN_DETAIL_IMG')
  static readonly NOTIFY_MESSAGE_IMAGE = new FileRefType('通知消息图片', 'NOTIFY_MESSAGE_IMAGE')
  static readonly ALBUM_FILE = new FileRefType('相册文件', 'ALBUM_FILE')
  private static readonly VALUES: FileRefType[] = [this.ACCOUNT_AVATAR, this.ACCOUNT_IDCARD, this.ACCOUNT_IMAGE, this.PRIV_IMG, this.SELLER_LOGO, this.SELLER_CERTIFICATE, this.SKILL_CERTIFICATE, this.RES_IMG, this.AUDIT_IMG, this.PAY_CHANNEL_IMG, this.WITHDRAW_CHANNEL_IMG, this.ORDER_IMG, this.ORDER_ITEM_IMG, this.WORK_ORDER_IMG, this.SPU_LOGO, this.SPU_IMG, this.SKU_IMG, this.TRAN_DETAIL_IMG, this.NOTIFY_MESSAGE_IMAGE, this.ALBUM_FILE] as const

  static names(): FileRefTypeName[] {
    return ['ACCOUNT_AVATAR', 'ACCOUNT_IDCARD', 'ACCOUNT_IMAGE', 'PRIV_IMG', 'SELLER_LOGO', 'SELLER_CERTIFICATE', 'SKILL_CERTIFICATE', 'RES_IMG', 'AUDIT_IMG', 'PAY_CHANNEL_IMG', 'WITHDRAW_CHANNEL_IMG', 'ORDER_IMG', 'ORDER_ITEM_IMG', 'WORK_ORDER_IMG', 'SPU_LOGO', 'SPU_IMG', 'SKU_IMG', 'TRAN_DETAIL_IMG', 'NOTIFY_MESSAGE_IMAGE', 'ALBUM_FILE']
  }

  static values(): FileRefType[] {
    return this.VALUES
  }

  static fromValue(value?: string): FileRefType | undefined {
    return value === undefined ? undefined : FileRefType.values().find(e => e.value === value)
  }
}
export type GenderTypeName = 'MALE' | 'FEMALE' | 'SECRET'
export class GenderType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly MALE = new GenderType('男', 'MALE')
  static readonly FEMALE = new GenderType('女', 'FEMALE')
  static readonly SECRET = new GenderType('保密', 'SECRET')
  private static readonly VALUES: GenderType[] = [this.MALE, this.FEMALE, this.SECRET] as const

  static names(): GenderTypeName[] {
    return ['MALE', 'FEMALE', 'SECRET']
  }

  static values(): GenderType[] {
    return this.VALUES
  }

  static fromValue(value?: string): GenderType | undefined {
    return value === undefined ? undefined : GenderType.values().find(e => e.value === value)
  }
}
export type LimitOpTypeName = 'CANCEL' | 'CANCEL_ALL' | 'AUTO'
export class LimitOpType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly CANCEL = new LimitOpType('取消', 'CANCEL')
  static readonly CANCEL_ALL = new LimitOpType('取消所有', 'CANCEL_ALL')
  static readonly AUTO = new LimitOpType('自动', 'AUTO')
  private static readonly VALUES: LimitOpType[] = [this.CANCEL, this.CANCEL_ALL, this.AUTO] as const

  static names(): LimitOpTypeName[] {
    return ['CANCEL', 'CANCEL_ALL', 'AUTO']
  }

  static values(): LimitOpType[] {
    return this.VALUES
  }

  static fromValue(value?: string): LimitOpType | undefined {
    return value === undefined ? undefined : LimitOpType.values().find(e => e.value === value)
  }
}
export type LoginTypeName = 'CODE' | 'PWD' | 'THIRD'
export class LoginType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly CODE = new LoginType('验证码', 'CODE')
  static readonly PWD = new LoginType('密码', 'PWD')
  static readonly THIRD = new LoginType('授权', 'THIRD')
  private static readonly VALUES: LoginType[] = [this.CODE, this.PWD, this.THIRD] as const

  static names(): LoginTypeName[] {
    return ['CODE', 'PWD', 'THIRD']
  }

  static values(): LoginType[] {
    return this.VALUES
  }

  static fromValue(value?: string): LoginType | undefined {
    return value === undefined ? undefined : LoginType.values().find(e => e.value === value)
  }
}
export type NotifyMsgReceiverTypeName = 'USER' | 'PROVIDER' | 'SELLER'
export class NotifyMsgReceiverType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly USER = new NotifyMsgReceiverType('用户', 'USER')
  static readonly PROVIDER = new NotifyMsgReceiverType('茶艺师', 'PROVIDER')
  static readonly SELLER = new NotifyMsgReceiverType('卖家', 'SELLER')
  private static readonly VALUES: NotifyMsgReceiverType[] = [this.USER, this.PROVIDER, this.SELLER] as const

  static names(): NotifyMsgReceiverTypeName[] {
    return ['USER', 'PROVIDER', 'SELLER']
  }

  static values(): NotifyMsgReceiverType[] {
    return this.VALUES
  }

  static fromValue(value?: string): NotifyMsgReceiverType | undefined {
    return value === undefined ? undefined : NotifyMsgReceiverType.values().find(e => e.value === value)
  }
}
export type OpStatusName = 'PENDING' | 'SUCCESS' | 'FAILED'
export class OpStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PENDING = new OpStatus('待执行', 'PENDING')
  static readonly SUCCESS = new OpStatus('执行成功', 'SUCCESS')
  static readonly FAILED = new OpStatus('执行失败', 'FAILED')
  private static readonly VALUES: OpStatus[] = [this.PENDING, this.SUCCESS, this.FAILED] as const

  static names(): OpStatusName[] {
    return ['PENDING', 'SUCCESS', 'FAILED']
  }

  static values(): OpStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): OpStatus | undefined {
    return value === undefined ? undefined : OpStatus.values().find(e => e.value === value)
  }
}
export type OrderRefundStatusName = 'NONE' | 'REFUND_PART' | 'REFUND_ALL' | 'REJECTED' | 'CANCELED'
export class OrderRefundStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly NONE = new OrderRefundStatus('无', 'NONE')
  static readonly REFUND_PART = new OrderRefundStatus('部分退款', 'REFUND_PART')
  static readonly REFUND_ALL = new OrderRefundStatus('全部退款', 'REFUND_ALL')
  static readonly REJECTED = new OrderRefundStatus('拒绝退款', 'REJECTED')
  static readonly CANCELED = new OrderRefundStatus('取消退款', 'CANCELED')
  private static readonly VALUES: OrderRefundStatus[] = [this.NONE, this.REFUND_PART, this.REFUND_ALL, this.REJECTED, this.CANCELED] as const

  static names(): OrderRefundStatusName[] {
    return ['NONE', 'REFUND_PART', 'REFUND_ALL', 'REJECTED', 'CANCELED']
  }

  static values(): OrderRefundStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): OrderRefundStatus | undefined {
    return value === undefined ? undefined : OrderRefundStatus.values().find(e => e.value === value)
  }
}
export type OrderStatusName = 'CREATED' | 'PAID' | 'ACCEPT' | 'DELIVERING_PART' | 'DELIVERING_ALL' | 'DELIVERED' | 'SETTLED' | 'CANCELED' | 'CLOSED'
export class OrderStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly CREATED = new OrderStatus('待付款', 'CREATED')
  static readonly PAID = new OrderStatus('待接单', 'PAID')
  static readonly ACCEPT = new OrderStatus('待交付', 'ACCEPT')
  static readonly DELIVERING_PART = new OrderStatus('部分发货', 'DELIVERING_PART')
  static readonly DELIVERING_ALL = new OrderStatus('待确认', 'DELIVERING_ALL')
  static readonly DELIVERED = new OrderStatus('待结算', 'DELIVERED')
  static readonly SETTLED = new OrderStatus('已完成', 'SETTLED')
  static readonly CANCELED = new OrderStatus('已取消', 'CANCELED')
  static readonly CLOSED = new OrderStatus('已关闭', 'CLOSED')
  private static readonly VALUES: OrderStatus[] = [this.CREATED, this.PAID, this.ACCEPT, this.DELIVERING_PART, this.DELIVERING_ALL, this.DELIVERED, this.SETTLED, this.CANCELED, this.CLOSED] as const

  static names(): OrderStatusName[] {
    return ['CREATED', 'PAID', 'ACCEPT', 'DELIVERING_PART', 'DELIVERING_ALL', 'DELIVERED', 'SETTLED', 'CANCELED', 'CLOSED']
  }

  static values(): OrderStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): OrderStatus | undefined {
    return value === undefined ? undefined : OrderStatus.values().find(e => e.value === value)
  }
}
export type PayArgTypeName = 'URL' | 'QRCODE' | 'HTML' | 'DATA'
export class PayArgType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly URL = new PayArgType('链接', 'URL')
  static readonly QRCODE = new PayArgType('二维码', 'QRCODE')
  static readonly HTML = new PayArgType('页面', 'HTML')
  static readonly DATA = new PayArgType('数据', 'DATA')
  private static readonly VALUES: PayArgType[] = [this.URL, this.QRCODE, this.HTML, this.DATA] as const

  static names(): PayArgTypeName[] {
    return ['URL', 'QRCODE', 'HTML', 'DATA']
  }

  static values(): PayArgType[] {
    return this.VALUES
  }

  static fromValue(value?: string): PayArgType | undefined {
    return value === undefined ? undefined : PayArgType.values().find(e => e.value === value)
  }
}
export type PayOrderTypeName = 'PAY' | 'RECHARGE'
export class PayOrderType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PAY = new PayOrderType('支付', 'PAY')
  static readonly RECHARGE = new PayOrderType('充值', 'RECHARGE')
  private static readonly VALUES: PayOrderType[] = [this.PAY, this.RECHARGE] as const

  static names(): PayOrderTypeName[] {
    return ['PAY', 'RECHARGE']
  }

  static values(): PayOrderType[] {
    return this.VALUES
  }

  static fromValue(value?: string): PayOrderType | undefined {
    return value === undefined ? undefined : PayOrderType.values().find(e => e.value === value)
  }
}
export type PayStatusName = 'WAITING' | 'PENDING' | 'SUCCESS' | 'FAILED'
export class PayStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly WAITING = new PayStatus('待支付', 'WAITING')
  static readonly PENDING = new PayStatus('支付中', 'PENDING')
  static readonly SUCCESS = new PayStatus('已支付', 'SUCCESS')
  static readonly FAILED = new PayStatus('已失败', 'FAILED')
  private static readonly VALUES: PayStatus[] = [this.WAITING, this.PENDING, this.SUCCESS, this.FAILED] as const

  static names(): PayStatusName[] {
    return ['WAITING', 'PENDING', 'SUCCESS', 'FAILED']
  }

  static values(): PayStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): PayStatus | undefined {
    return value === undefined ? undefined : PayStatus.values().find(e => e.value === value)
  }
}
export type PickTypeName = 'VIRTUAL' | 'PICK_SELF' | 'SHIPPING'
export class PickType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly VIRTUAL = new PickType('虚拟商品', 'VIRTUAL')
  static readonly PICK_SELF = new PickType('上门自提', 'PICK_SELF')
  static readonly SHIPPING = new PickType('物流寄送', 'SHIPPING')
  private static readonly VALUES: PickType[] = [this.VIRTUAL, this.PICK_SELF, this.SHIPPING] as const

  static names(): PickTypeName[] {
    return ['VIRTUAL', 'PICK_SELF', 'SHIPPING']
  }

  static values(): PickType[] {
    return this.VALUES
  }

  static fromValue(value?: string): PickType | undefined {
    return value === undefined ? undefined : PickType.values().find(e => e.value === value)
  }
}
export type ProcessStatusName = 'NONE' | 'WAITING' | 'PENDING' | 'SUCCESS' | 'FAILED' | 'CANCELED'
export class ProcessStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly NONE = new ProcessStatus('无', 'NONE')
  static readonly WAITING = new ProcessStatus('待开始', 'WAITING')
  static readonly PENDING = new ProcessStatus('处理中', 'PENDING')
  static readonly SUCCESS = new ProcessStatus('已成功', 'SUCCESS')
  static readonly FAILED = new ProcessStatus('已失败', 'FAILED')
  static readonly CANCELED = new ProcessStatus('已取消', 'CANCELED')
  private static readonly VALUES: ProcessStatus[] = [this.NONE, this.WAITING, this.PENDING, this.SUCCESS, this.FAILED, this.CANCELED] as const

  static names(): ProcessStatusName[] {
    return ['NONE', 'WAITING', 'PENDING', 'SUCCESS', 'FAILED', 'CANCELED']
  }

  static values(): ProcessStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): ProcessStatus | undefined {
    return value === undefined ? undefined : ProcessStatus.values().find(e => e.value === value)
  }
}
export type ProductStatusName = 'DRAFT' | 'PENDING_AUDIT' | 'AUDIT_REJECT' | 'ON_SALE' | 'OFF_SALE'
export class ProductStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly DRAFT = new ProductStatus('草稿箱', 'DRAFT')
  static readonly PENDING_AUDIT = new ProductStatus('待审核', 'PENDING_AUDIT')
  static readonly AUDIT_REJECT = new ProductStatus('审核失败', 'AUDIT_REJECT')
  static readonly ON_SALE = new ProductStatus('上架', 'ON_SALE')
  static readonly OFF_SALE = new ProductStatus('下架', 'OFF_SALE')
  private static readonly VALUES: ProductStatus[] = [this.DRAFT, this.PENDING_AUDIT, this.AUDIT_REJECT, this.ON_SALE, this.OFF_SALE] as const

  static names(): ProductStatusName[] {
    return ['DRAFT', 'PENDING_AUDIT', 'AUDIT_REJECT', 'ON_SALE', 'OFF_SALE']
  }

  static values(): ProductStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): ProductStatus | undefined {
    return value === undefined ? undefined : ProductStatus.values().find(e => e.value === value)
  }
}
export type ProductTypeName = 'GOODS' | 'VIRTUAL'
export class ProductType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly GOODS = new ProductType('实物商品', 'GOODS')
  static readonly VIRTUAL = new ProductType('虚拟商品', 'VIRTUAL')
  private static readonly VALUES: ProductType[] = [this.GOODS, this.VIRTUAL] as const

  static names(): ProductTypeName[] {
    return ['GOODS', 'VIRTUAL']
  }

  static values(): ProductType[] {
    return this.VALUES
  }

  static fromValue(value?: string): ProductType | undefined {
    return value === undefined ? undefined : ProductType.values().find(e => e.value === value)
  }
}
export type ProfitTypeName = 'INCOME' | 'SERVICE_FEE' | 'CHANNEL_FEE'
export class ProfitType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly INCOME = new ProfitType('销售收入', 'INCOME')
  static readonly SERVICE_FEE = new ProfitType('服务费', 'SERVICE_FEE')
  static readonly CHANNEL_FEE = new ProfitType('渠道推广费', 'CHANNEL_FEE')
  private static readonly VALUES: ProfitType[] = [this.INCOME, this.SERVICE_FEE, this.CHANNEL_FEE] as const

  static names(): ProfitTypeName[] {
    return ['INCOME', 'SERVICE_FEE', 'CHANNEL_FEE']
  }

  static values(): ProfitType[] {
    return this.VALUES
  }

  static fromValue(value?: string): ProfitType | undefined {
    return value === undefined ? undefined : ProfitType.values().find(e => e.value === value)
  }
}
export type RefundStatusName = 'NONE' | 'PENDING' | 'SUCCESS' | 'FAILED'
export class RefundStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly NONE = new RefundStatus('无', 'NONE')
  static readonly PENDING = new RefundStatus('退款中', 'PENDING')
  static readonly SUCCESS = new RefundStatus('退款成功', 'SUCCESS')
  static readonly FAILED = new RefundStatus('退款失败', 'FAILED')
  private static readonly VALUES: RefundStatus[] = [this.NONE, this.PENDING, this.SUCCESS, this.FAILED] as const

  static names(): RefundStatusName[] {
    return ['NONE', 'PENDING', 'SUCCESS', 'FAILED']
  }

  static values(): RefundStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): RefundStatus | undefined {
    return value === undefined ? undefined : RefundStatus.values().find(e => e.value === value)
  }
}
export type ResourceTypeName = 'ROOM'
export class ResourceType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ROOM = new ResourceType('房间', 'ROOM')
  private static readonly VALUES: ResourceType[] = [this.ROOM] as const

  static names(): ResourceTypeName[] {
    return ['ROOM']
  }

  static values(): ResourceType[] {
    return this.VALUES
  }

  static fromValue(value?: string): ResourceType | undefined {
    return value === undefined ? undefined : ResourceType.values().find(e => e.value === value)
  }
}
export type ReviewStatusName = 'PENDING' | 'DELETING' | 'SUCCESS' | 'FAILED'
export class ReviewStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PENDING = new ReviewStatus('审核中', 'PENDING')
  static readonly DELETING = new ReviewStatus('删除待审核', 'DELETING')
  static readonly SUCCESS = new ReviewStatus('审核成功', 'SUCCESS')
  static readonly FAILED = new ReviewStatus('审核失败', 'FAILED')
  private static readonly VALUES: ReviewStatus[] = [this.PENDING, this.DELETING, this.SUCCESS, this.FAILED] as const

  static names(): ReviewStatusName[] {
    return ['PENDING', 'DELETING', 'SUCCESS', 'FAILED']
  }

  static values(): ReviewStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): ReviewStatus | undefined {
    return value === undefined ? undefined : ReviewStatus.values().find(e => e.value === value)
  }
}
export type RoleTypeName = 'ADMIN' | 'USER' | 'EMPLOYEE' | 'PROVIDER'
export class RoleType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ADMIN = new RoleType('管理员', 'ADMIN')
  static readonly USER = new RoleType('用户', 'USER')
  static readonly EMPLOYEE = new RoleType('商户', 'EMPLOYEE')
  static readonly PROVIDER = new RoleType('服务商', 'PROVIDER')
  private static readonly VALUES: RoleType[] = [this.ADMIN, this.USER, this.EMPLOYEE, this.PROVIDER] as const

  static names(): RoleTypeName[] {
    return ['ADMIN', 'USER', 'EMPLOYEE', 'PROVIDER']
  }

  static values(): RoleType[] {
    return this.VALUES
  }

  static fromValue(value?: string): RoleType | undefined {
    return value === undefined ? undefined : RoleType.values().find(e => e.value === value)
  }
}
export type SettleStatusName = 'PENDING' | 'READY' | 'SETTLED' | 'CANCELED'
export class SettleStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly PENDING = new SettleStatus('待结算', 'PENDING')
  static readonly READY = new SettleStatus('可结算', 'READY')
  static readonly SETTLED = new SettleStatus('已结算', 'SETTLED')
  static readonly CANCELED = new SettleStatus('取消结算', 'CANCELED')
  private static readonly VALUES: SettleStatus[] = [this.PENDING, this.READY, this.SETTLED, this.CANCELED] as const

  static names(): SettleStatusName[] {
    return ['PENDING', 'READY', 'SETTLED', 'CANCELED']
  }

  static values(): SettleStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): SettleStatus | undefined {
    return value === undefined ? undefined : SettleStatus.values().find(e => e.value === value)
  }
}
export type StockTypeName = 'AVAILABLE' | 'LOCKED'
export class StockType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly AVAILABLE = new StockType('可用库存', 'AVAILABLE')
  static readonly LOCKED = new StockType('锁定库存', 'LOCKED')
  private static readonly VALUES: StockType[] = [this.AVAILABLE, this.LOCKED] as const

  static names(): StockTypeName[] {
    return ['AVAILABLE', 'LOCKED']
  }

  static values(): StockType[] {
    return this.VALUES
  }

  static fromValue(value?: string): StockType | undefined {
    return value === undefined ? undefined : StockType.values().find(e => e.value === value)
  }
}
export type ThirdAccountTypeName = 'WEIXIN_MP' | 'WEIXIN_OF' | 'WEIXIN_APP' | 'WEIXIN_WEB' | 'DOUYIN_MP' | 'DOUYIN_APP' | 'DOUYIN_WEB'
export class ThirdAccountType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly WEIXIN_MP = new ThirdAccountType('微信小程序', 'WEIXIN_MP')
  static readonly WEIXIN_OF = new ThirdAccountType('微信公众号', 'WEIXIN_OF')
  static readonly WEIXIN_APP = new ThirdAccountType('微信APP', 'WEIXIN_APP')
  static readonly WEIXIN_WEB = new ThirdAccountType('微信网页', 'WEIXIN_WEB')
  static readonly DOUYIN_MP = new ThirdAccountType('抖音小程序', 'DOUYIN_MP')
  static readonly DOUYIN_APP = new ThirdAccountType('抖音APP', 'DOUYIN_APP')
  static readonly DOUYIN_WEB = new ThirdAccountType('抖音网页', 'DOUYIN_WEB')
  private static readonly VALUES: ThirdAccountType[] = [this.WEIXIN_MP, this.WEIXIN_OF, this.WEIXIN_APP, this.WEIXIN_WEB, this.DOUYIN_MP, this.DOUYIN_APP, this.DOUYIN_WEB] as const

  static names(): ThirdAccountTypeName[] {
    return ['WEIXIN_MP', 'WEIXIN_OF', 'WEIXIN_APP', 'WEIXIN_WEB', 'DOUYIN_MP', 'DOUYIN_APP', 'DOUYIN_WEB']
  }

  static values(): ThirdAccountType[] {
    return this.VALUES
  }

  static fromValue(value?: string): ThirdAccountType | undefined {
    return value === undefined ? undefined : ThirdAccountType.values().find(e => e.value === value)
  }
}
export type TradeBizTypeName = 'INCREASE' | 'DECREASE' | 'RECHARGE' | 'WITHDRAW' | 'WITHDRAW_SUCCESS' | 'WITHDRAW_FAIL' | 'PAY_ORDER' | 'CANCEL_ORDER' | 'CANCEL_ORDER_ITEM' | 'ORDER_SETTLE'
export class TradeBizType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly INCREASE = new TradeBizType('增加', 'INCREASE')
  static readonly DECREASE = new TradeBizType('扣除', 'DECREASE')
  static readonly RECHARGE = new TradeBizType('充值', 'RECHARGE')
  static readonly WITHDRAW = new TradeBizType('提现', 'WITHDRAW')
  static readonly WITHDRAW_SUCCESS = new TradeBizType('提现成功', 'WITHDRAW_SUCCESS')
  static readonly WITHDRAW_FAIL = new TradeBizType('提现失败', 'WITHDRAW_FAIL')
  static readonly PAY_ORDER = new TradeBizType('订单付款', 'PAY_ORDER')
  static readonly CANCEL_ORDER = new TradeBizType('取消订单', 'CANCEL_ORDER')
  static readonly CANCEL_ORDER_ITEM = new TradeBizType('取消订单项', 'CANCEL_ORDER_ITEM')
  static readonly ORDER_SETTLE = new TradeBizType('订单结算', 'ORDER_SETTLE')
  private static readonly VALUES: TradeBizType[] = [this.INCREASE, this.DECREASE, this.RECHARGE, this.WITHDRAW, this.WITHDRAW_SUCCESS, this.WITHDRAW_FAIL, this.PAY_ORDER, this.CANCEL_ORDER, this.CANCEL_ORDER_ITEM, this.ORDER_SETTLE] as const

  static names(): TradeBizTypeName[] {
    return ['INCREASE', 'DECREASE', 'RECHARGE', 'WITHDRAW', 'WITHDRAW_SUCCESS', 'WITHDRAW_FAIL', 'PAY_ORDER', 'CANCEL_ORDER', 'CANCEL_ORDER_ITEM', 'ORDER_SETTLE']
  }

  static values(): TradeBizType[] {
    return this.VALUES
  }

  static fromValue(value?: string): TradeBizType | undefined {
    return value === undefined ? undefined : TradeBizType.values().find(e => e.value === value)
  }
}
export type ValueTypeName = 'AMOUNT' | 'RATE'
export class ValueType implements EnumItem<string> {
  public readonly displayUnit: string
  public readonly label: string
  public readonly precision: number
  public readonly valueUnit: string
  public readonly value: string

  private constructor(displayUnit: string, label: string, precision: number, valueUnit: string, value: string) {
    this.displayUnit = displayUnit
    this.label = label
    this.precision = precision
    this.valueUnit = valueUnit
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly AMOUNT = new ValueType('元', '固定金额', 2, '分', 'AMOUNT')
  static readonly RATE = new ValueType('%', '百分比', 2, '万分一', 'RATE')
  private static readonly VALUES: ValueType[] = [this.AMOUNT, this.RATE] as const

  static names(): ValueTypeName[] {
    return ['AMOUNT', 'RATE']
  }

  static values(): ValueType[] {
    return this.VALUES
  }

  static fromValue(value?: string): ValueType | undefined {
    return value === undefined ? undefined : ValueType.values().find(e => e.value === value)
  }
}
export type WalletTypeName = 'MONEY' | 'POINT'
export class WalletType implements EnumItem<string> {
  public readonly displayUnit: string
  public readonly itemName: string
  public readonly label: string
  public readonly precision: number
  public readonly valueUnit: string
  public readonly value: string

  private constructor(displayUnit: string, itemName: string, label: string, precision: number, valueUnit: string, value: string) {
    this.displayUnit = displayUnit
    this.itemName = itemName
    this.label = label
    this.precision = precision
    this.valueUnit = valueUnit
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly MONEY = new WalletType('元', '金额', '钱包', 2, '分', 'MONEY')
  static readonly POINT = new WalletType('分', '积分', '积分', 0, '分', 'POINT')
  private static readonly VALUES: WalletType[] = [this.MONEY, this.POINT] as const

  static names(): WalletTypeName[] {
    return ['MONEY', 'POINT']
  }

  static values(): WalletType[] {
    return this.VALUES
  }

  static fromValue(value?: string): WalletType | undefined {
    return value === undefined ? undefined : WalletType.values().find(e => e.value === value)
  }
}
export type WeiXinTypeName = 'MP' | 'OF' | 'WEB' | 'APP'
export class WeiXinType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly MP = new WeiXinType('小程序', 'MP')
  static readonly OF = new WeiXinType('公众号', 'OF')
  static readonly WEB = new WeiXinType('网页', 'WEB')
  static readonly APP = new WeiXinType('APP', 'APP')
  private static readonly VALUES: WeiXinType[] = [this.MP, this.OF, this.WEB, this.APP] as const

  static names(): WeiXinTypeName[] {
    return ['MP', 'OF', 'WEB', 'APP']
  }

  static values(): WeiXinType[] {
    return this.VALUES
  }

  static fromValue(value?: string): WeiXinType | undefined {
    return value === undefined ? undefined : WeiXinType.values().find(e => e.value === value)
  }
}
export type WithdrawStateName = 'ACCEPTED' | 'PROCESSING' | 'WAIT_USER_CONFIRM' | 'TRANSFERING' | 'SUCCESS' | 'FAILED' | 'CANCELING' | 'CANCELLED'
export class WithdrawState implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ACCEPTED = new WithdrawState('已受理', 'ACCEPTED')
  static readonly PROCESSING = new WithdrawState('处理中', 'PROCESSING')
  static readonly WAIT_USER_CONFIRM = new WithdrawState('等待用户确认', 'WAIT_USER_CONFIRM')
  static readonly TRANSFERING = new WithdrawState('提现中', 'TRANSFERING')
  static readonly SUCCESS = new WithdrawState('提现成功', 'SUCCESS')
  static readonly FAILED = new WithdrawState('提现失败', 'FAILED')
  static readonly CANCELING = new WithdrawState('撤销中', 'CANCELING')
  static readonly CANCELLED = new WithdrawState('已撤销', 'CANCELLED')
  private static readonly VALUES: WithdrawState[] = [this.ACCEPTED, this.PROCESSING, this.WAIT_USER_CONFIRM, this.TRANSFERING, this.SUCCESS, this.FAILED, this.CANCELING, this.CANCELLED] as const

  static names(): WithdrawStateName[] {
    return ['ACCEPTED', 'PROCESSING', 'WAIT_USER_CONFIRM', 'TRANSFERING', 'SUCCESS', 'FAILED', 'CANCELING', 'CANCELLED']
  }

  static values(): WithdrawState[] {
    return this.VALUES
  }

  static fromValue(value?: string): WithdrawState | undefined {
    return value === undefined ? undefined : WithdrawState.values().find(e => e.value === value)
  }
}
export type TriggerStateName = 'WAITING' | 'PAUSED' | 'ACQUIRED' | 'BLOCKED' | 'COMPLETE' | 'ERROR'
export class TriggerState implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly WAITING = new TriggerState('等待中', 'WAITING')
  static readonly PAUSED = new TriggerState('暂停中', 'PAUSED')
  static readonly ACQUIRED = new TriggerState('待执行', 'ACQUIRED')
  static readonly BLOCKED = new TriggerState('阻塞中', 'BLOCKED')
  static readonly COMPLETE = new TriggerState('已完成', 'COMPLETE')
  static readonly ERROR = new TriggerState('错误', 'ERROR')
  private static readonly VALUES: TriggerState[] = [this.WAITING, this.PAUSED, this.ACQUIRED, this.BLOCKED, this.COMPLETE, this.ERROR] as const

  static names(): TriggerStateName[] {
    return ['WAITING', 'PAUSED', 'ACQUIRED', 'BLOCKED', 'COMPLETE', 'ERROR']
  }

  static values(): TriggerState[] {
    return this.VALUES
  }

  static fromValue(value?: string): TriggerState | undefined {
    return value === undefined ? undefined : TriggerState.values().find(e => e.value === value)
  }
}
export type TriggerTypeName = 'SIMPLE' | 'CRON'
export class TriggerType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly SIMPLE = new TriggerType('普通策略', 'SIMPLE')
  static readonly CRON = new TriggerType('高级策略', 'CRON')
  private static readonly VALUES: TriggerType[] = [this.SIMPLE, this.CRON] as const

  static names(): TriggerTypeName[] {
    return ['SIMPLE', 'CRON']
  }

  static values(): TriggerType[] {
    return this.VALUES
  }

  static fromValue(value?: string): TriggerType | undefined {
    return value === undefined ? undefined : TriggerType.values().find(e => e.value === value)
  }
}
export type RegionTypeName = 'COUNTRY' | 'PROVINCE' | 'CITY' | 'COUNTY' | 'TOWN' | 'VILLAGE'
export class RegionType implements EnumItem<number> {
  public readonly label: string
  public readonly value: number

  private constructor(label: string, value: number) {
    this.label = label
    this.value = value
  }

  toString() {
    return String(this.value)
  }

  toJSON() {
    return this.value
  }

  static readonly COUNTRY = new RegionType('国家', 0)
  static readonly PROVINCE = new RegionType('省', 1)
  static readonly CITY = new RegionType('市', 2)
  static readonly COUNTY = new RegionType('区/县', 3)
  static readonly TOWN = new RegionType('乡镇/街道', 4)
  static readonly VILLAGE = new RegionType('村/社区', 5)
  private static readonly VALUES: RegionType[] = [this.COUNTRY, this.PROVINCE, this.CITY, this.COUNTY, this.TOWN, this.VILLAGE] as const

  static names(): RegionTypeName[] {
    return ['COUNTRY', 'PROVINCE', 'CITY', 'COUNTY', 'TOWN', 'VILLAGE']
  }

  static values(): RegionType[] {
    return this.VALUES
  }

  static fromValue(value?: number): RegionType | undefined {
    return value === undefined ? undefined : RegionType.values().find(e => e.value === value)
  }
}
export type ErrorCodeName = 'REQ_ERR' | 'NOT_LOGIN' | 'PERMISSION_DENIED' | 'REQ_ARG' | 'REQ_TIMEOUT' | 'ACCESS_TIMEOUT' | 'SVR_ERR' | 'SVR_NOT_FOUND' | 'SVR_NET_ERR' | 'SVR_DISABLE' | 'SVR_TIMEOUT' | 'BINDED_REPEAT' | 'REPEAT_BINDED' | 'INSUFFICIENT_BALANCE'
export class ErrorCode implements EnumItem<number> {
  public readonly label: string
  public readonly value: number

  private constructor(label: string, value: number) {
    this.label = label
    this.value = value
  }

  toString() {
    return String(this.value)
  }

  toJSON() {
    return this.value
  }

  static readonly REQ_ERR = new ErrorCode('请求错误', 400)
  static readonly NOT_LOGIN = new ErrorCode('没有登录', 401)
  static readonly PERMISSION_DENIED = new ErrorCode('无权操作', 403)
  static readonly REQ_ARG = new ErrorCode('请求参数不正确', 404)
  static readonly REQ_TIMEOUT = new ErrorCode('请求超时', 408)
  static readonly ACCESS_TIMEOUT = new ErrorCode('请求令牌过期', 419)
  static readonly SVR_ERR = new ErrorCode('服务端错误', 500)
  static readonly SVR_NOT_FOUND = new ErrorCode('服务不存在', 501)
  static readonly SVR_NET_ERR = new ErrorCode('网络错误', 502)
  static readonly SVR_DISABLE = new ErrorCode('服务不可用', 503)
  static readonly SVR_TIMEOUT = new ErrorCode('网络超时', 505)
  static readonly BINDED_REPEAT = new ErrorCode('绑定重复', 601)
  static readonly REPEAT_BINDED = new ErrorCode('重复绑定', 602)
  static readonly INSUFFICIENT_BALANCE = new ErrorCode('余额不足', 701)
  private static readonly VALUES: ErrorCode[] = [this.REQ_ERR, this.NOT_LOGIN, this.PERMISSION_DENIED, this.REQ_ARG, this.REQ_TIMEOUT, this.ACCESS_TIMEOUT, this.SVR_ERR, this.SVR_NOT_FOUND, this.SVR_NET_ERR, this.SVR_DISABLE, this.SVR_TIMEOUT, this.BINDED_REPEAT, this.REPEAT_BINDED, this.INSUFFICIENT_BALANCE] as const

  static names(): ErrorCodeName[] {
    return ['REQ_ERR', 'NOT_LOGIN', 'PERMISSION_DENIED', 'REQ_ARG', 'REQ_TIMEOUT', 'ACCESS_TIMEOUT', 'SVR_ERR', 'SVR_NOT_FOUND', 'SVR_NET_ERR', 'SVR_DISABLE', 'SVR_TIMEOUT', 'BINDED_REPEAT', 'REPEAT_BINDED', 'INSUFFICIENT_BALANCE']
  }

  static values(): ErrorCode[] {
    return this.VALUES
  }

  static fromValue(value?: number): ErrorCode | undefined {
    return value === undefined ? undefined : ErrorCode.values().find(e => e.value === value)
  }
}
export type FileTypeName = 'AUDIO' | 'VIDEO' | 'IMAGE' | 'DOCUMENT' | 'ARCHIVE' | 'LINK' | 'OTHER'
export class FileType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly AUDIO = new FileType('音频', 'AUDIO')
  static readonly VIDEO = new FileType('视频', 'VIDEO')
  static readonly IMAGE = new FileType('图片', 'IMAGE')
  static readonly DOCUMENT = new FileType('文档', 'DOCUMENT')
  static readonly ARCHIVE = new FileType('压缩包', 'ARCHIVE')
  static readonly LINK = new FileType('链接', 'LINK')
  static readonly OTHER = new FileType('其它', 'OTHER')
  private static readonly VALUES: FileType[] = [this.AUDIO, this.VIDEO, this.IMAGE, this.DOCUMENT, this.ARCHIVE, this.LINK, this.OTHER] as const

  static names(): FileTypeName[] {
    return ['AUDIO', 'VIDEO', 'IMAGE', 'DOCUMENT', 'ARCHIVE', 'LINK', 'OTHER']
  }

  static values(): FileType[] {
    return this.VALUES
  }

  static fromValue(value?: string): FileType | undefined {
    return value === undefined ? undefined : FileType.values().find(e => e.value === value)
  }
}
export type NodeTypeName = 'LEAF' | 'LIMB'
export class NodeType implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly LEAF = new NodeType('叶子', 'LEAF')
  static readonly LIMB = new NodeType('枝干', 'LIMB')
  private static readonly VALUES: NodeType[] = [this.LEAF, this.LIMB] as const

  static names(): NodeTypeName[] {
    return ['LEAF', 'LIMB']
  }

  static values(): NodeType[] {
    return this.VALUES
  }

  static fromValue(value?: string): NodeType | undefined {
    return value === undefined ? undefined : NodeType.values().find(e => e.value === value)
  }
}
export type UsableStatusName = 'ENABLE' | 'DISABLE'
export class UsableStatus implements EnumItem<string> {
  public readonly label: string
  public readonly value: string

  private constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }

  toString() {
    return this.value
  }

  toJSON() {
    return this.value
  }

  static readonly ENABLE = new UsableStatus('启用', 'ENABLE')
  static readonly DISABLE = new UsableStatus('停用', 'DISABLE')
  private static readonly VALUES: UsableStatus[] = [this.ENABLE, this.DISABLE] as const

  static names(): UsableStatusName[] {
    return ['ENABLE', 'DISABLE']
  }

  static values(): UsableStatus[] {
    return this.VALUES
  }

  static fromValue(value?: string): UsableStatus | undefined {
    return value === undefined ? undefined : UsableStatus.values().find(e => e.value === value)
  }
}
